import React, { useState, useEffect } from "react";
import { Redirect, useParams } from "react-router-dom";
import Alert from "./Alert";
import Loading from "./Loading";

/**
 * Transient component that validates a claiming link, then redirects to the
 * Welcome page (on success) or displays an error and redirects to "Tell us who you are"
 */

const Validate = props => {
	const [validated, setValidated] = useState(false);
	const [alertState, setAlertState] = useState({});
	const [tokenInvalid, setTokenInvalid] = useState(false);
	const [loading, setLoading] = useState(true);

	let { token } = useParams();
	const { setUser, setToken, apiService, setRouteToWelcome } = props;

	useEffect(() => {
		const handleValidate = async () => {
			if (!token) return;
			const result = await apiService.validate_token(token);
			if (!result.ok) {
				setLoading(false);
				setUser(result.user);
				const invalidTokenMessage = {
					title: "Sorry, the email link is not valid",
					message: "This could mean that it has already been used for account setup or that it has expired. Would you like to set a password now?",
				}
				setAlertState({
					title: result.message === "Token not valid" ? invalidTokenMessage.title : "Oops",
					message: result.message === "Token not valid" ? invalidTokenMessage.message : "Oops, something went wrong. Please try again.",
					buttonTextPrimary: "Set my password",
					onClickPrimary: () => {
						setRouteToWelcome(true);
						setTokenInvalid(true);
					}
				});
				return;
			}
			setUser(result.user);
			setToken(result.token);
			setValidated(true);
		};
		handleValidate();
	}, [setUser, token, setToken, apiService, setRouteToWelcome]);

	// After user closes 'something went wrong' alert,
	const handleCloseAlert = () => {
		setAlertState({});
		setTokenInvalid(true);
	};

	if (validated) return <Redirect push from="/validate" to="/welcome" />;
	if (tokenInvalid) return <Redirect psuh from="/validate" to="/telluswhoyouare" />;

	return (
		<>
			{alertState.message && <Alert {...alertState} close={handleCloseAlert} />}
			{loading && <Loading loadingMessage="Verifying..." />}
		</>
	);
};

export default Validate;
